import React from 'react';
import { ArrowDownIcon, BookOpenIcon, PrinterIcon, RulerIcon, StoreIcon } from 'lucide-react';
import { PREVIEW_ANCHOR } from '../../data/collection';
import { secondaryLinkClass } from '../../utils/buttonStyles';
const BENEFITS = [{
  icon: PrinterIcon,
  title: 'Moldes listos para imprimir',
  text: 'No tenés que diseñar ni dibujar tus propios patrones. Elegí el modelo, imprimí los moldes en A4 y prepará las piezas para empezar a confeccionar.'
}, {
  icon: BookOpenIcon,
  title: 'Ideal para principiantes',
  text: 'Cada modelo incluye su manual de confección con instrucciones paso a paso, desde la preparación y el corte hasta el armado y las terminaciones.'
}, {
  icon: StoreIcon,
  title: 'Empezá tu propio emprendimiento',
  text: 'Tené una colección de 31 modelos infantiles para confeccionar tus primeras prendas y comenzar a armar tu catálogo de productos.'
}, {
  icon: RulerIcon,
  title: '10 talles para ofrecer más opciones',
  text: 'Cada modelo incluye moldes Multi-talle por estatura, desde 50 hasta 104 cm, para que puedas confeccionar distintas medidas.'
}];

/** Four short benefits, no price. */
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-158" data-mp="16ypsj0gc6da7">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 lg:py-16" data-id="element-159" data-mp="1bycepze573v5">
        <h2 id="beneficios-title" className="sr-only" data-id="element-160" data-mp="1c0owabfznc7o">
          Qué incluye la colección
        </h2>
        <ul className="grid grid-cols-1 gap-x-10 divide-y divide-dashed divide-coral/35 md:grid-cols-2 md:gap-y-10 md:divide-y-0 lg:grid-cols-4 lg:gap-x-8 [&>*]:min-w-0" data-id="element-161" data-mp="120o8ac76c7x5">
          {BENEFITS.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5 first:pt-0 last:pb-0 md:flex-col md:gap-3 md:py-0" data-id="element-162" data-mp="t7l0ajfasn9w">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blush text-coral-ink" data-id="element-163" data-mp="ec4zlvk7pt4j">
                <Icon className="h-5 w-5" aria-hidden data-id="element-164" data-mp="j9orhy9u24ey" />
              </span>
              <div className="min-w-0" data-id="element-165" data-mp="6mune6j5gch">
                <h3 className="font-serif text-[1.3rem] font-semibold leading-tight text-graphite sm:text-[1.45rem]" data-id="element-166" data-mp="7o8triueiyf">{title}</h3>
                <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-167" data-mp="3mkwgbfj2sa9k">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex justify-center md:mt-10" data-id="element-168" data-mp="3hnwczcdm1lm5">
          <a href={PREVIEW_ANCHOR} className={secondaryLinkClass} data-id="element-169" data-mp="j4pgjk3s6x62">
            Mirá cómo viene por dentro
            <ArrowDownIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-170" data-mp="e6e4d2q0kako" />
          </a>
        </div>
      </div>
    </section>;
}